import type { ICrmListPageApiService } from "app/pages/sales-intelligence/modules/lists/sub-modules/crm-list/services/api/types";
import type { CrmListDto, ListsDto } from "app/pages/sales-intelligence/modules/lists/types/dto";
import type { GetRequestOptions, IFetchService } from "app/services/fetchService";

const LIST_PATH_PREFIX = "/sales-api/user-assets";
const createCrmListPageAPIService = (fetchService: Readonly<IFetchService>): ICrmListPageApiService => {
    return {
        fetchList(
            params: Readonly<{ page: number; pageSize: number }>,
            options?: Readonly<GetRequestOptions>,
        ): Promise<ListsDto<CrmListDto>> {
            return fetchService.get(`${LIST_PATH_PREFIX}/crm-lists`, params, options);
        },
    };
};

export default createCrmListPageAPIService;
